import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DragulaService } from 'ng2-dragula';
import { InterfaceElement } from 'src/app/model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { CosyDynaeditorControllerService } from 'src/app/service/controller/cosy-dynaeditor-controller.service';
import { UXControllerService } from 'src/app/service/controller/ux-controller.service';

//import * as _ from 'lodash';
import cloneDeep from 'lodash-es/cloneDeep';
@Component({
  selector: 'app-cosy-dynaeditor-entity',
  templateUrl: './cosy-dynaeditor-entity.component.html',
  styleUrls: ['../cosy-dynaeditor.component.css','./cosy-dynaeditor-entity.component.css']
})
export class CosyDynaeditorEntityComponent implements OnInit {

  @Input() dynaEditorElement:InterfaceElement;
  @Input() dynaItem:any;
  @Output() dynaItemChange = new EventEmitter();
  @Output() saveDEData = new EventEmitter();
 
  public ie: InterfaceElement;
  public ieNew : InterfaceElement;
  public availableEntities: any[] = [];
  public visibleEntities: any[] = [];
  public entityCode: string = 'E-';
  
  public showEntityDetail: boolean;
  public isAllowSort: boolean;
  public isVisible: boolean;
  public dynaEntityForm: any;


  constructor(private uxControllerService: UXControllerService,
    private cosyDynaeditorControllerService: CosyDynaeditorControllerService,
    private formBuilder: FormBuilder,
    private dragulaService: DragulaService) {
      dragulaService.drop("entity-items").subscribe(value => {
                 
        if (value.target.id == 'VisibleEntities') {
          document.getElementById('E-' + value.el.id).style.visibility = 'visible';
        }
        if (value.target.id == 'AvailableEntities') {
          document.getElementById('E-' + value.el.id).style.visibility = 'hidden';
        }
         this.cosyDynaeditorControllerService.dynaEditorProcessing(value, 'drag', this.dynaEditorElement['ie'], this.uxControllerService.cosyFormInitProperties);
      });

    }

  ngOnInit() {
    this.ie = this.dynaEditorElement['ie'];
    this.loadDynaEditorData();
  }

  updateFormValues(updatedDynaForm, actionType){
    this.saveDEData.emit(updatedDynaForm);
    this.showEntityDetail = false;
  }

  loadDynaEntityEditForm(item: any) {
    this.isAllowSort = false;
    this.isVisible = false;
    this.dynaEntityForm = this.formBuilder.group({
      ID: [item.InterfaceElementID],
      displayName: [item.DisplayProperties.DisplayName],
      allowSort: [item.AllowSorting],
      name: [item.Name],
      displayFormat: [item.Attributes.DisplayFormat]
    });
  }

  editDynaEntityEditorItem(dynaEditEntity: any) {
    this.dynaItem = dynaEditEntity;
    this.dynaItemChange.emit(this.dynaItem);
    this.loadDynaEntityEditForm(dynaEditEntity);
    this.showEntityDetail = true;
  }
  
  loadDynaEditorData(){
    this.visibleEntities = [];
    this.availableEntities = [];
    let ieIndex: number = -1;
    this.ieNew = new InterfaceElement();
    
    this.uxControllerService.cosyFormInitProperties.CustomAppStateDocument =  cloneDeep(this.cosyDynaeditorControllerService.processedCASD)
    ieIndex = this.uxControllerService.cosyFormInitProperties.CustomAppStateDocument.InterfaceElements.map(function (d) {
      return d['InterfaceElementID'];
    }).indexOf(this.ie.InterfaceElementID);
   

   for (let iee of this.ie.InterfaceElements) {
        if (iee.Attributes.Visible) {
          this.visibleEntities.push(iee);
        } else {
          this.availableEntities.push(iee);
        }
      }
      this.visibleEntities.sort((a, b) => a.Attributes.DisplayOrder - b.Attributes.DisplayOrder);
    
      if (ieIndex < 0) {
        this.ieNew.InterfaceElementID = this.ie.InterfaceElementID;
        this.ieNew.InterfaceElements = [];
        this.uxControllerService.cosyFormInitProperties.CustomAppStateDocument.InterfaceElements.push(this.ieNew);
        this.cosyDynaeditorControllerService.processedCASD.InterfaceElements.push(this.ieNew);
       // this.cosyAppStateDataControllerService.processedCASD.InterfaceElements.push(this.ieNew);
     }     
  }

}
